import React from 'react';
import ReactMarkdown from 'react-markdown';
import { SystemMessage as SystemMessageType } from 'types/chat.types';
import classfiLogo from 'assets/logo/classfi_no_name.png';

interface SystemMessageProps {
  message: SystemMessageType;
}

const SystemMessage: React.FC<SystemMessageProps> = ({ message }) => {
  const { content, timestamp } = message;

  return (
    <div className="self-start flex flex-col">
      <div className="bg-white border border-gray-200 px-4 py-3 rounded-2xl rounded-bl-md max-w-2xl">
        {/* Header with Logo */}
        <div className="flex items-center gap-2 mb-2">
          <div className="w-[20.4px] h-[20.4px] flex items-center justify-center">
            <img src={classfiLogo} alt="Classfi" className="w-full h-full object-contain" />
          </div>
          <div className="flex items-center gap-2">
            <p className="font-semibold text-[#263238] text-[13px] leading-[1.4]">System</p>
            <span className="text-[#8c8c8c] text-[11px] font-light leading-[1.2]">
              | {timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </span>
          </div>
        </div>

        {/* Content */}
        <div className="text-[13px] text-gray-700 font-light">
          <ReactMarkdown
            components={{
              p: ({node, ...props}) => <p className="mb-0" {...props} />,
              strong: ({node, ...props}) => <strong className="font-semibold" {...props} />,
              em: ({node, ...props}) => <em className="italic" {...props} />,
              code: ({node, ...props}) => <code className="bg-gray-200 px-1 rounded" {...props} />,
            }}
          >
            {content}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default SystemMessage;
